// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentWidget_root__Y8ogL"};